<template>
  <v-app>
    <v-content id="forget" class="primary">
      <v-container class="fill-height mt-16" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-stepper v-model="e1">
              <!-- <v-toolbar color="white" dark flat>
                <div class="layout column">
                  <img src="@/assets/glyd.png" width="140" height="140" />
                </div>
                <v-toolbar-title class="primary--text"
                  ><b>RESET PASSWORD</b></v-toolbar-title
                >
              </v-toolbar> -->
              <div class="layout column align-center">
                <img src="@/assets/glyd.png" width="140" height="140" />

                <!-- <h1 class="flex my-2">Sign In</h1> -->

                <span class="mt-n7 mb-3"><b>RESET PASSWORD</b></span>
              </div>
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1"
                  >Email</v-stepper-step
                >

                <v-divider></v-divider>
                <!-- kbkhvkh -->
                <v-stepper-step :complete="e1 > 2" step="2"
                  >Code</v-stepper-step
                >

                <v-divider></v-divider>

                <v-stepper-step step="3">Password</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-form
                    ref="step1Form"
                    v-model="firstFormValid"
                    lazy-validation
                    class="mt-1"
                  >
                    <span class="font-weight-bold subtitle-2"
                      >Enter Your Login User Id and Registered Email</span
                    >
                    <v-text-field
                      v-model="display_id"
                      label="Login User ID *"
                      type="text"
                      required
                      append-icon="mdi-identifier"
                      dense
                      class="mb-6 mt-5"
                      @keyup.enter="login"
                      :rules="[(v) => !!v || 'Login user id is required']"
                      @keyup="capsfnction()"
                    ></v-text-field>

                    <v-text-field
                      class="mt-n5"
                      v-model="email"
                      label="Email *"
                      :rules="[
                        (v) => !!v || 'E-mail is required',
                        (v) => /.+@.+/.test(v) || 'E-mail must be valid',
                      ]"
                      name="email"
                      append-icon="mdi-email"
                      type="text"
                      required
                    />

                    <v-btn
                      :loading="step1loading"
                      @click="onClickStep1()"
                      class="btn mb-3 primary--text"
                      >Continue</v-btn
                    >

                    <v-btn text @click="onBackClick()" rounded class="mb-3 ml-2"
                      >Back</v-btn
                    >
                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-form
                    ref="step2Form"
                    v-model="secondFormValid"
                    lazy-validation
                    class="mt-5"
                  >
                    <span class="font-weight-bold"
                      >Enter code sent to your registered Email</span
                    >
                    <v-text-field
                      class="mt-5 mb-2"
                      v-model="code"
                      label="Code"
                      :rules="rules.code"
                      append-icon="mdi-key-variant"
                      type="text"
                      required
                    />

                    <v-btn
                      :loading="step2loading"
                      @click="onClickStep2()"
                      class="btn mb-3 primary--text"
                      >Continue</v-btn
                    >

                    <v-btn text @click="onBackClick()" rounded class="mb-3 ml-2"
                      >Back</v-btn
                    >
                  </v-form>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-form
                    ref="step3Form"
                    v-model="finalFormValid"
                    lazy-validation
                    class="mt-5"
                  >
                    <span class="font-weight-bold">Reset password.</span>
                    <v-text-field
                      class="mt-5"
                      label="New Password"
                      v-model="newPassword"
                      :rules="pwdRules"
                      name="password"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show ? 'text' : 'password'"
                      @click:append="show = !show"
                      required
                    />

                    <v-text-field
                      class="mb-2"
                      label="Confirm Password"
                      v-model="confirmPassword"
                      :rules="pwdConfirm"
                      name="password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      @click:append="show1 = !show1"
                      required
                    />

                    <v-btn
                      :loading="step3loading"
                      @click="confirmPwd()"
                      class="mb-3 primary--text btn"
                      >Confirm</v-btn
                    >

                    <v-btn text @click="onBackClick()" rounded class="mb-3 ml-2"
                      >Back</v-btn
                    >
                  </v-form>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <!--snackbar-->
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ text }}
      <v-btn text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
// import { Auth } from "aws-amplify";
//import axios from "axios";
import { apiCall } from "../APICALL/APIcall.js";
export default {
  data() {
    return {
      step3loading: false,
      step2loading: false,
      step1loading: false,
      show: false,
      show1: false,
      snackbarColor: "",
      snackbar: false,
      text: "",
      firstFormValid: true,
      secondFormValid: true,
      finalFormValid: true,
      e1: 1,
      email: "",
      display_id: "",
      code: "",
      newPassword: "",
      confirmPassword: "",
      pwdConfirm: [
        (v) => !!v || "Confirm password",
        (v) => v === this.newPassword || "Passwords do not match",
      ],
      pwdRules: [(v) => !!v || "Password required"],
      rules: {
        email: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
        code: [(v) => !!v || "Code is required"],
        newPassword: [
          (v) => !!v || "required !",
          (v) => (v && v.length >= 8) || "Min 8 characters",
        ],
        confirmPassword: [
          (v) => !!v || "required !",
          (v) => (v && v.length >= 8) || "Min 8 characters",
        ],
      },
    };
  },
  methods: {
    capsfnction() {
      this.display_id = this.display_id.toUpperCase();
    },
    async confirmPwd() {
      if (this.$refs.step3Form.validate()) {
        var inputData = {
          method_name: "CAUTH",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "FPVCODE",
            email_id: this.email.trim(),
            vcode: this.code,
            new_password: this.confirmPassword,
            display_id: this.display_id,
          },
        };
        var responseData = await apiCall(inputData);
        // console.log("FPVCODE", responseData);
        if (responseData.data.status == "00") {
          this.$router.push("/");
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            timeout: 10000,
            color: "green",
          });
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
        }
      }
    },
    onClickStep2() {
      if (this.$refs.step2Form.validate()) {
        this.e1 = 3;
      }
    },
    async onClickStep1() {
      if (this.$refs.step1Form.validate()) {
        var inputData = {
          method_name: "CAUTH",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "FGTPWD",
            email_id: this.email.trim(),
            display_id: this.display_id,
          },
        };
        var responseData = await apiCall(inputData);
        // console.log("CAUTHFGTPWD", responseData);
        if (responseData.data.status == "InputVerificationCode") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
          this.e1 = 2;
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
        }
      }
    },
    onBackClick() {
      if (this.e1 !== 1) {
        this.e1--;
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>
<style>
.btn {
  background: linear-gradient(
    90deg,
    rgba(165, 126, 60, 1) 0%,
    rgba(223, 192, 126, 1) 50%,
    rgba(165, 126, 60, 1) 100%
  );
}
</style>
<style lang="css">
.bg {
  background: #1b3249 !important;
}

#forget {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.navbar {
  background: linear-gradient(
    to bottom,
    #2e4152 0%,
    #3c4d5d 50%,
    #202c37 100%
  ) !important;
}
</style>
